import script from "./FilePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./FilePreview.vue?vue&type=script&setup=true&lang=js"

import "./FilePreview.vue?vue&type=style&index=0&id=9061d6a2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9061d6a2"]])

export default __exports__